/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_0_TitleInputs */

const en_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 Iowa PGA Match Play Champion`)
};

const es_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeón de match play de la Iowa PGA en 1988`)
};

const de_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lochspielmeister der Iowa PGA 1988`)
};

const zh_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 年 Iowa PGA 比洞赛冠军`)
};

const ar_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطل Iowa PGA Match Play لعام 1988`)
};

const fr_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champion de match-play de la Iowa PGA en 1988`)
};

const vi_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch đấu lỗ Iowa PGA 1988`)
};

const sw_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bingwa wa Iowa PGA Match Play 1988`)
};

const th_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์แมตช์เพลย์ของ Iowa PGA ปี 1988`)
};

const bs_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion Iowa PGA Match Play 1988.`)
};

const ja_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988年 Iowa PGA マッチプレー優勝`)
};

const ko_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 Iowa PGA 매치플레이 챔피언`)
};

const pt_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeão de match play da Iowa PGA em 1988`)
};

const it_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione di match play della Iowa PGA nel 1988`)
};

const sv_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchspelsmästare i Iowa PGA 1988`)
};

const nl_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchplaykampioen van de Iowa PGA 1988`)
};

const da_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hulspilsmester i Iowa PGA 1988`)
};

const nb_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchspillmester i Iowa PGA 1988`)
};

const fi_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n reikäpelimestari 1988`)
};

const pl_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrz Iowa PGA w grze na dołki 1988`)
};

const ru_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпион Iowa PGA по матчевой игре 1988 года`)
};

const tr_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 Iowa PGA Match Play şampiyonu`)
};

const hi_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 Iowa PGA मैच प्ले चैंपियन`)
};

const id_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa PGA Match Play 1988`)
};

const ms_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa PGA Match Play 1988`)
};

const cs_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion Iowa PGA v jamkové hře 1988`)
};

const el_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητής match play της Iowa PGA 1988`)
};

const he_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלוף Iowa PGA Match Play לשנת 1988`)
};

const af_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1988 Iowa PGA-putjiespelkampioen`)
};

const hu_about_content_competitive_0_title = /** @type {(inputs: About_Content_Competitive_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA 1988-as lyukjátékbajnoka`)
};

/**
* | output |
* | --- |
* | "1988 Iowa PGA Match Play Champion" |
*
* @param {About_Content_Competitive_0_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_0_title = /** @type {((inputs?: About_Content_Competitive_0_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_0_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_0_title(inputs)
	if (locale === "de") return de_about_content_competitive_0_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_0_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_0_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_0_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_0_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_0_title(inputs)
	if (locale === "th") return th_about_content_competitive_0_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_0_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_0_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_0_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_0_title(inputs)
	if (locale === "it") return it_about_content_competitive_0_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_0_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_0_title(inputs)
	if (locale === "da") return da_about_content_competitive_0_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_0_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_0_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_0_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_0_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_0_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_0_title(inputs)
	if (locale === "id") return id_about_content_competitive_0_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_0_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_0_title(inputs)
	if (locale === "el") return el_about_content_competitive_0_title(inputs)
	if (locale === "he") return he_about_content_competitive_0_title(inputs)
	if (locale === "af") return af_about_content_competitive_0_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_0_title(inputs)
	return en_about_content_competitive_0_title(inputs)
});